/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type LastLoggedInUserMode = 'Hide' | 'Show' | 'Window';

export const LastLoggedInUserMode = {
    Hide: 'Hide' as LastLoggedInUserMode,
    Show: 'Show' as LastLoggedInUserMode,
    Window: 'Window' as LastLoggedInUserMode
};

